import React, { useState, useEffect } from 'react'
import style from './index.module.scss'
import {
    // reuqestAuthRegister,
    // tokenUserNamePassword,
    // accountPasswordUser,
    // authCheck,
    // phoneCheckCode,
    // checkPhone,
    // checkEmail,
    // tokenUserNamePassword,
    checkEmail,
    checkPhone,
    verifyImage
} from '../../api/login'
import {
    hasuser
} from '../../api/user'
import { userModule } from '../../modules/user'
import loginbaidu from '../../static/image/loginbaidu.png'
// import loginuser from '../../static/image/loginuser.png'
import loginarrright from '../../static/image/loginarrright.png'
import loginarract from '../../static/image/loginarract.png'
// import baidu from '../../static/image/baidu.png'
// import up from '../../static/image/up.png'
import { message } from 'antd'

import baidu from './baidu.png'

import { GithubOutlined, GitlabOutlined, WechatOutlined } from '@ant-design/icons';

interface Props {
    history: any;
}

interface State {
    name: string;
    type: string;
    password: string;
    phone: string;
    code: string;
    regitype: string;
    reginame: string;
    regipass: string;
    regicheck: string;
    regiphone: string;
    regimail: string;
    regicode: string;
    base64: string;
    piccode: string;
    picval: string;
    islogin: boolean;
    checkpassword: string;
    showpop: boolean;
    textInput: any
}

const Login = (props: Props) => {
    const [step, setStep] = useState<string>('login')
    const [timing, setTiming] = useState<boolean>(false)
    // const [check , setcheck] = useState<boolean>(true)
    // const [checkname , setcheckname] = useState<boolean>(true)
    // const [checkmail , setcheckmail] = useState<boolean>(true)
    const [state, setState] = useState<State>({
        name: '',
        type: 'name',
        password: '',
        phone: '',
        code: '',
        regitype: 'name',
        reginame: '',
        regipass: '',
        regicheck: '',
        regiphone: '',
        regimail: '',
        regicode: '',
        base64: '',
        piccode: '',
        picval: '',
        islogin: true,
        checkpassword: '',
        showpop: false,
        textInput: ''
    })

    useEffect(() => {
        // verifyImage(100, 100);
        localStorage.clear()
    }, [])
    useEffect(() => {
        state.textInput.focus()
    }, [step, state.showpop])

    const reset = () => {
        setState({
            name: '',
            type: 'name',
            password: '',
            phone: '',
            code: '',
            regitype: 'name',
            reginame: '',
            regipass: '',
            regicheck: '',
            regiphone: '',
            regimail: '',
            regicode: '',
            base64: '',
            piccode: '',
            picval: '',
            islogin: true,
            checkpassword: '',
            showpop: false,
            textInput: ''
        })
    }

    // const sendCode = async (phone: string) => {
    //     userModule.sendPhoneCode(
    //         phone, ['regicode', 'logincode'], [
    //         () => {
    //             setStep('register')
    //         },
    //         () => {
    //             setStep('loginphone')
    //         }
    //     ]);
    // }

    /**
     * @name 登录
     */
    const onLogin = async (type: any): Promise<any> => {
        if (type == 'gitLab') {
            await userModule.gitLabLogin();
        } else if (type == 'weChat') {
            await userModule.gitWechatLogin();
        }

    }
    // 校验输入,决定走哪种类型，哪步骤
    const checknameres = () => {
        const name = state.name;
        if ((name || '').trim().replace(/\s/g, '') !== name) {
            return
        } else if (/^1[3|4|5|7|8][0-9]{9}$/.test(name)) {
        } else if (/^\S+@\S+\.\S+$/.test(name)) {
        } else if (name && !/^[0-9]+$/.test(name)) {
            if (name.length > 50) {
                return
            }
        } else {
            return
        }

        return true;
    }
    const checkname = async (hideerr?: any) => {
        const name = state.name;
        if ((name || '').trim().replace(/\s/g, '') !== name) {
            if (!hideerr) {
                message.error('输入内容不能有空格')
            }
            return
        } else if (/^1[3|4|5|7|8][0-9]{9}$/.test(name)) {
            if (!hideerr) {
                state.type = 'phone'
            }
        } else if (/^\S+@\S+\.\S+$/.test(name)) {
            if (!hideerr) {
                state.type = 'email'
            }
        } else if (name && !/^[0-9]+$/.test(name)) {
            if (!hideerr) {
                state.type = 'name'
            }
            if (name.length > 50) {
                if (!hideerr) {
                    message.error('用户名最多50字')
                }
                return
            }
        } else {
            if (!hideerr) {
                message.error('请输入正确的用户名，手机号，邮箱，且格式正确，用户名不能都为数字')
            }
            return
        }
        if (!hideerr) {

            if (state.type === 'name') {
                // setState({
                //     ...state,
                //     base64: '',
                //     password: '',
                //     regicode: '',
                //     piccode: ''
                // });
                let login = true;
                try {
                    const res: any = await hasuser(state.name);
                    if (res.ok) {
                        login = true;
                    } else {
                        console.log(res)
                        if (res.code === 404) {
                            login = false;
                        }
                    }
                } catch (err) {
                    login = false;
                }
                genImagePic({
                    password: '',
                    regicode: '',
                    piccode: '',
                    islogin: login
                })
                setStep('password')
            }
            if (state.type === 'email' || state.type === 'phone') {
                // setState({
                //     ...state,
                //     base64: '',
                //     password: '',
                //     regicode: '',
                //     piccode: ''
                // });
                let login = true;
                if (state.type === 'email') {
                    try {
                        let res: any = await checkEmail(state.name);
                        if (res.ok) {
                            login = true;
                        } else {
                            if (res.code === 404) {
                                login = false;
                            }
                        }
                    } catch (err) {
                        login = false;
                    }
                } else if (state.type === 'phone') {
                    try {
                        let res: any = await checkPhone(state.name);
                        if (res.ok) {
                            login = true;
                        } else {
                            if (res.code === 404) {
                                login = false;
                            }
                        }
                    } catch (err) {
                        login = false;
                    }
                }
                genImagePic({
                    password: '',
                    regicode: '',
                    piccode: '',
                    islogin: login
                });
                setTiming(false);
                setStep('regcode');
            }
        }
        return true;
    }
    // 生成图片码
    const genImagePic = async (tarstate?: any) => {
        const res = await verifyImage(150, 60);
        state.base64 = res.data.base64;
        state.code = res.data.code;
        state.picval = res.data.value;
        tarstate = tarstate || null
        setState({
            ...state,
            ...tarstate
        });
    }
    // 用户名密码登录包含注册
    const normalLogin = async () => {
        let user = {};
        if (state.password.trim().replace(/\s/g, '') !== state.password) {
            message.error('密码不能带有空格')
            return
        } else if (state.type === 'name') {
            if (!state.islogin) {
                if (state.password !== state.checkpassword) {
                    message.error('两次密码不一致')
                    return
                }
            }
            user = await userModule.normalLogin(state.name, state.password);
        } else if (state.type === 'phone') {
            user = await userModule.phonePasswordLogin(state.name, state.password);
        } else if (state.type === 'email') {
            user = await userModule.emailPasswordLogin(state.name, state.password);
        }
        reset();

        userModule.redirectPageByUser(user, props.history, true);
    }
    const getpincode = () => {
        genImagePic({
            piccode: '',
            showpop: true
        })
    }
    const popconfirm = async () => {
        try {
            if (!state.piccode) {// ||  state.piccode !== state.picval) {
                message.error('请输入正确图片验证码')
                return
            } else {
                let code = ''
                if (state.type === 'phone') {
                    code = await userModule.sendPhoneCode(
                        state.name,
                        state.code,
                        state.piccode,
                        ['regicode'], [
                        () => {
                            setTiming(false);
                        }
                    ]
                    );
                } else if (state.type === 'email') {
                    code = await userModule.sendMailCode(
                        state.name,
                        state.code,
                        state.piccode,
                        ['regicode'], [
                        () => {
                            setTiming(false);

                        }
                    ]
                    );
                }
                setState({
                    ...state,
                    code,
                    regicode: '',
                    showpop: false
                });
                setTiming(true);
                message.info('验证码已经发送')
                // setStep('regcode')
            }
        } catch (e) {
            genImagePic()
            state.piccode = ''
            setState({ ...state })
            // console.log(code)
        }
    }
    // 跳转输入验证码
    // const toSendCode = async () => {
    //     if (!state.piccode) {// ||  state.piccode !== state.picval) {
    //         message.error('请输入正确图片验证码')
    //         return
    //     } else {
    //         let code = ''
    //         if (state.type === 'phone') {
    //             code = await userModule.sendPhoneCode(
    //                 state.name,
    //                 state.code,
    //                 state.piccode,
    //                 ['regicode'], [
    //                     () => {
    //                         genImagePic()
    //                         setStep('regcode')
    //                     }
    //                 ]
    //             );
    //         } else if (state.type === 'email') {
    //             code = await userModule.sendMailCode(
    //                 state.name,
    //                 state.code,
    //                 state.piccode,
    //                 ['regicode'], [
    //                     () => {
    //                         genImagePic()
    //                         setStep('regcode')
    //                     }
    //                 ]
    //             );
    //         }
    //         setState({
    //             ...state,
    //             code
    //         });
    //         message.info('验证码已经发送')
    //         setStep('regcode')
    //     }
    // }
    // 手机邮箱验证码，登录或者注册
    const codeRegiOrLogin = async () => {
        if (!state.regicode) {
            message.error('请输入验证码')
        }
        let user = {}
        console.log('sssss', state.type)
        if (state.type === 'email') {
            user = await userModule.emialLogin(state.code, state.regicode, state.name);
        } else if (state.type === 'phone') {
            user = await userModule.phoneLogin(state.code, state.regicode, state.name);
        }
        reset();
        userModule.redirectPageByUser(user, props.history, true);
    }
    return (
        <div className={style.bg} >
            <div className={`${style.all} unselect`} data-flex='dir:top main:center cross:center'>
                <div className={`${style.top} ${style[step]}`}>
                    {
                        (step === 'login'
                            || step === 'password'
                            || step === 'piccode'
                            || step === 'regcode'
                            || step === 'logined') &&
                        <React.Fragment>
                            <div className={style.btn}></div>
                        </React.Fragment>
                    }
                    {
                        step === 'register' &&
                        <div className={style.btn2}></div>
                    }
                </div>
                {
                    step === 'login' &&
                    <div className={style.rige}>
                        <div className={style.inputline}>
                            <input className={style.input}
                                placeholder='请输入用户名/手机号/邮箱'
                                ref={(input) => { state.textInput = input; }}
                                value={state.name}
                                onKeyPress={(e: any) => {
                                    if (e.code === 'Enter') {
                                        checkname()
                                    }
                                }}
                                onInput={(e: any) => {
                                    setState({
                                        ...state,
                                        name: e.target.value
                                    })
                                }}
                            />
                            <img className={style.inputright + ' ' + (checknameres() ? style.on : '')} alt=""
                                src={checknameres() ? loginarract : loginarrright}
                                onClick={() => {
                                    checkname()
                                }} />
                        </div>
                    </div>
                }
                {
                    step === 'password' &&
                    <div className={style.rige}>
                        <div className={style.msg}>
                            {
                                state.islogin ?
                                    <span>正在使用<span className={style.white}>{state.name}</span>登录</span> :
                                    <span>正在使用<span className={style.white}>{state.name}</span>注册</span>
                            }
                        </div>
                        <div className={style.inputline}>
                            <input className={style.input} placeholder='密码'
                                type='password'
                                value={state.password}
                                onKeyPress={(e: any) => {
                                    if (e.code === 'Enter') {
                                        if (state.password) {
                                            normalLogin()
                                        }
                                    }
                                }}
                                ref={(input) => { state.textInput = input; }}
                                onInput={(e: any) => {
                                    setState({
                                        ...state,
                                        password: e.target.value
                                    })
                                }} />
                            {
                                state.islogin && <img className={style.inputright + ' ' + (state.password ? style.on : '')}
                                    alt=""
                                    src={state.password ? loginarract : loginarrright}
                                    onClick={() => {
                                        if (state.password) {
                                            normalLogin()
                                        }

                                    }} />}
                        </div>
                        {
                            !state.islogin && state.type === 'name' && <>
                                <div className={style.inputline}>
                                    <input className={style.input} placeholder='校验密码'
                                        ref={(input) => { state.textInput = input; }}
                                        type='password'
                                        value={state.checkpassword}
                                        onInput={(e: any) => {
                                            setState({
                                                ...state,
                                                checkpassword: e.target.value
                                            })
                                        }} />
                                    <img className={style.inputright + ' ' + (state.password ? style.on : '')}
                                        alt=""
                                        src={state.password ? loginarract : loginarrright}
                                        onClick={() => {
                                            if (state.password) {
                                                normalLogin()
                                            }
                                        }} />
                                </div>

                            </>
                        }
                    </div>
                }
                {/* {
                step === 'piccode' &&
                <div className={style.rige}>
                    <div className={style.inputline}>
                        <input className={style.input} placeholder='输入图片验证码'
                            value={state.piccode}
                            onInput={(e: any) => {
                                setState({
                                    ...state,
                                    piccode: e.target.value
                                })
                            }} />
                        <div className={style.baseImg}>
                            <img alt=""
                                onClick={() => {
                                    genImagePic();
                                }}
                                className={style.basePicImg} src={state.base64}></img>
                        </div>
                        <img className={style.inputright} alt=""
                             src={state.piccode ? loginarract : loginarrright}
                             onClick={() => {
                                toSendCode()
                             }}/>
                    </div>
                </div>
            } */}
                {
                    step === 'regcode' &&
                    <div className={style.rige}>
                        <div className={style.msg}>
                            {
                                state.islogin ?
                                    <span>
                                        正在使用
                                        <span className={style.white}>
                                            {state.name}
                                        </span>
                                        登录
                                    </span> :
                                    <span>
                                        正在使用
                                        <span className={style.white}>
                                            {state.name}
                                        </span>
                                        注册
                                    </span>
                            }
                        </div>
                        <div className={style.inputline}>
                            <input className={style.input} placeholder='输入验证码'
                                ref={(input) => { state.textInput = input; }}
                                value={state.regicode}
                                onKeyPress={(e: any) => {
                                    if (e.code === 'Enter') {
                                        codeRegiOrLogin()
                                    }
                                }}
                                onInput={(e: any) => {
                                    setState({
                                        ...state,
                                        regicode: e.target.value
                                    })
                                }} />
                            {
                                timing ?
                                    <div className={style.baseImg} id="regicode">
                                    </div> :
                                    <div className={style.getcode}
                                        onClick={() => {
                                            getpincode()
                                        }}>
                                        获取验证码
                                    </div>
                            }
                            <img className={style.inputright + ' ' + (state.regicode ? style.on : '')} alt=""
                                src={state.regicode ? loginarract : loginarrright}
                                onClick={() => {
                                    codeRegiOrLogin()
                                }} />
                        </div>
                    </div>
                }
                {
                    (step === 'regcode' && state.islogin) &&
                    <div className={style.tips}
                        onClick={() => {
                            setStep('password');
                            setState({
                                ...state,
                                regicode: ''
                            })
                        }}>
                        密码登录
                    </div>
                }
                {
                    (step === 'password' &&
                        (state.type === 'email' || state.type === 'phone')) &&
                    <div className={style.tips}
                        onClick={() => {
                            genImagePic();
                            setTiming(false);
                            setStep('regcode');
                            state.password = ''
                            setState({
                                ...state,
                            })
                            console.log(11, state.password)
                        }}>
                        {state.type === 'email' ? '邮箱' : '短信'}验证码登录
                    </div>
                }
                <div className={style.sec} data-flex='main":left'>
                    {
                        (step === 'login') ?
                            <
                                >
                                <div className={style.baidubtn} >
                                    <div data-flex="main:center cross:center" onClick={
                                        () => {
                                            onLogin('gitLab');
                                        }
                                    }>
                                        <GitlabOutlined className={style.img} style={{ fontSize: '28px' }}
                                        />
                                    </div>
                                    <div className={style.icon_txt + ' tc'}>GitLab登录</div>
                                </div>
                                <div className={style.baidubtn}>
                                    <div data-flex="main:center cross:center" onClick={
                                        () => {
                                            onLogin('weChat');
                                        }
                                    }>
                                        <WechatOutlined className={style.img} style={{ fontSize: '28px' }}
                                        />
                                    </div>
                                    <div className={style.icon_txt + ' tc'}>微信登录</div>
                                </div>
                            </> :
                            <>
                                <div className={style.secLeft}>
                                    {
                                        (step === 'password') &&
                                        <img className={style.img} src={loginarract} alt=""
                                            style={{ transform: 'rotate(180deg)' }}
                                            onClick={
                                                () => {
                                                    reset();
                                                    setStep('login')
                                                }
                                            } />
                                    }
                                    {
                                        step === 'piccode' &&
                                        <img className={style.img} src={loginarract} alt=""
                                            style={{ transform: 'rotate(180deg)' }}
                                            onClick={
                                                () => {
                                                    reset();
                                                    setStep('login')
                                                }
                                            } />
                                    }
                                    {
                                        (step === 'regcode') &&
                                        <img className={style.img} src={loginarract} alt=""
                                            style={{ transform: 'rotate(180deg)' }}
                                            onClick={
                                                () => {
                                                    reset();
                                                    setStep('login')
                                                }
                                            } />
                                    }
                                </div>
                                <div className={style.secMid}>
                                </div>
                                <div className={style.secRight} data-flex="main:right cross:center">
                                    <GitlabOutlined className={style.img} style={{ fontSize: '28px' }} onClick={
                                        () => {
                                            onLogin('gitLab');
                                        }
                                    } />
                                    <WechatOutlined className={style.img} style={{ fontSize: '28px' }} onClick={
                                        () => {
                                            onLogin('weChat');
                                        }
                                    } />
                                </div>
                            </>
                    }
                </div>
                {/* <div className={style.ddd}>
                    <a target="_blank" rel="noreferrer" href="https://beian.miit.gov.cn">
                        京ICP备2021007214号-3
                    </a>
                </div> */}
                {
                    state.showpop ?
                        <div className={style.popup}>
                            <div className={style.popupcontent}>
                                <div className={style.poptip}>
                                    输入图片验证码，获取{state.type === 'email' ? '邮箱' : '短信'}验证码
                                </div>
                                <div className={style.popinpuline}>
                                    <input className={style.popinput}
                                        placeholder='请输入图片验证码'
                                        ref={(input) => { state.textInput = input; }}
                                        value={state.piccode}
                                        onKeyPress={(e: any) => {
                                            if (e.code === 'Enter') {
                                                popconfirm()
                                            }
                                        }}
                                        onInput={(e: any) => {
                                            setState({
                                                ...state,
                                                piccode: e.target.value
                                            })
                                        }} />
                                    <img alt=""
                                        onClick={() => {
                                            genImagePic();
                                        }}
                                        className={style.basePicImg} src={state.base64}></img>
                                </div>
                                <div className={style.popbtns}>
                                    <div className={style.popbtn}
                                        onClick={
                                            () => {
                                                setState({
                                                    ...state,
                                                    showpop: false
                                                })
                                            }
                                        }>
                                        取消
                                    </div>
                                    <div className={style.popbtn + ' ' + style.on}
                                        onClick={() => {
                                            popconfirm()
                                        }}>
                                        确定
                                    </div>
                                </div>
                            </div>
                        </div> : ''
                }
            </div>
        </div >
    )
}

export default Login
